import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  DateLessThanValidator,
  MustHaveStartDateIfEndDateValidator
} from 'src/app/shared/validators/date.validator';
import { LineupErrorStateMatcher } from 'src/app/shared/services/error-state-matcher.service';

export interface SeatDateEditData {
  personName: string;
  startDate: Date | null;
  endDate: Date | null;
  showFor: 'startDate' | 'endDate';
}

@Component({
  selector: 'app-seat-date-edit-modal',
  templateUrl: './seat-date-edit-modal.component.html',
  standalone: false
})
export class SeatDateEditModalComponent {
  dateForm: UntypedFormGroup;
  matcher = new LineupErrorStateMatcher();
  saving = false;

  constructor(
    public dialogRef: MatDialogRef<SeatDateEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SeatDateEditData,
    private fb: UntypedFormBuilder
  ) {
    this.dateForm = this.fb.group({
      startDate: [data.startDate],
      endDate: [data.endDate]
    });

    this.dateForm.setValidators([
      DateLessThanValidator('startDate', 'endDate'),
      MustHaveStartDateIfEndDateValidator('startDate', 'endDate')
    ]);
  }

  save() {
    if (this.dateForm.valid) {
      this.saving = true;
      this.dialogRef.close({
        startDate: this.dateForm.value.startDate ? new Date(this.dateForm.value.startDate) : null,
        endDate: this.dateForm.value.endDate ? new Date(this.dateForm.value.endDate) : null
      });
    }
  }
}
